import React from 'react';
import { Skeleton } from 'antd';
import { Card } from '@clockout-dev/design-elements';

/**
 * Loading placeholder rendered in place of a card while its data is in
 * flight. Wraps an antd `Skeleton` inside the design-elements `Card`
 * so the chrome (radius, padding, shadow) matches the real card it
 * stands in for, and the layout does not jump when the content lands.
 *
 * Pure presentational. Consumers control the reserved height via
 * `minHeight` so each slot keeps the same vertical footprint as the
 * card it temporarily replaces.
 *
 * @param {object} props
 * @param {number} [props.minHeight]   reserved height in px
 * @param {number} [props.rows=4]      number of skeleton paragraph rows
 */
function CardSkeleton({ minHeight, rows = 4 }) {
    return (
        <Card style={minHeight ? { minHeight } : undefined}>
            <Skeleton active paragraph={{ rows }} />
        </Card>
    );
}

export default CardSkeleton;
